import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function CountdownRibbon() {
  return (
    <div data-testid="countdown-ribbon" className="relative z-10 bg-[#E05A47] text-white">
      <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-center gap-x-6 gap-y-1.5 px-6 py-3 sm:px-10 lg:px-16">
        <p className="font-mono text-[11px] font-bold uppercase tracking-[0.25em]">
          VeloPaths is live — now on the App Store and Google Play
        </p>
        <Link
          to="/riders#waitlist"
          data-testid="ribbon-waitlist-link"
          className="-my-3 inline-flex items-center gap-1 py-3 font-mono text-[11px] font-bold uppercase tracking-[0.2em] underline decoration-white/50 underline-offset-4 transition-colors hover:decoration-white"
        >
          Get the app <ArrowUpRight size={12} />
        </Link>
      </div>
    </div>
  );
}
